module.exports = __webpack_public_path__ + "static/media/enterprise.139fd66c.png";